import { createContext } from 'react';
import config from 'config';
import useLocalStorage from 'hooks/useLocalStorage';
import {
    ConfigProviderProps,
    CustomizationProps,
    FontFamily,
    I18n,
    MenuOrientation,
    PresetColor,
    ThemeDirection,
    ThemeMode,
    FirstBuilderStart,
} from 'types/config';

const initialState: CustomizationProps = {
    ...config,
    onChangeContainer: () => {},
    onChangeLocalization: (lang: I18n) => {},
    onChangeMode: (mode: ThemeMode) => {},
    onChangePresetColor: (theme: PresetColor) => {},
    onChangeDirection: (direction: ThemeDirection) => {},
    onChangeMiniDrawer: (miniDrawer: boolean) => {},
    onChangeMenuOrientation: (menuOrientation: MenuOrientation) => {},
    onChangeFontFamily: (fontFamily: FontFamily) => {},
    onChangeshowBuilderGuide: (showBuilderGuide: boolean) => {},
    onChangeFirstBuilderStart: (firstBuilderStart: FirstBuilderStart) => {},
};

const ConfigContext = createContext(initialState);

function ConfigProvider({ children }: ConfigProviderProps) {
    const [config, setConfig] = useLocalStorage('lexis-config', initialState);

    const onChangeContainer = () => {
        setConfig({
            ...config,
            container: !config.container,
        });
    };

    const onChangeLocalization = (lang: I18n) => {
        setConfig({
            ...config,
            i18n: lang,
        });
    };

    const onChangeMode = (mode: ThemeMode) => {
        setConfig({
            ...config,
            mode,
        });
    };

    const onChangePresetColor = (theme: PresetColor) => {
        setConfig({
            ...config,
            presetColor: theme,
        });
    };

    const onChangeDirection = (direction: ThemeDirection) => {
        setConfig({
            ...config,
            themeDirection: direction,
        });
    };

    const onChangeMiniDrawer = (miniDrawer: boolean) => {
        setConfig({
            ...config,
            miniDrawer,
        });
    };

    const onChangeMenuOrientation = (layout: MenuOrientation) => {
        setConfig({
            ...config,
            menuOrientation: layout,
        });
    };

    const onChangeFontFamily = (fontFamily: FontFamily) => {
        setConfig({
            ...config,
            fontFamily,
        });
    };

    const onChangeFirstBuilderStart = (firstBuilderStart: FirstBuilderStart) => {
        setConfig({
            ...config,
            firstBuilderStart,
        });
    };
    const onChangeshowBuilderGuide = (showBuilderGuide: boolean) => {
        setConfig({
            ...config,
            showBuilderGuide,
        });
    };

    return (
        <ConfigContext.Provider
            value={{
                ...config,
                onChangeContainer,
                onChangeLocalization,
                onChangeMode,
                onChangePresetColor,
                onChangeDirection,
                onChangeMiniDrawer,
                onChangeMenuOrientation,
                onChangeFontFamily,
                onChangeshowBuilderGuide,
                onChangeFirstBuilderStart,
            }}>
            {children}
        </ConfigContext.Provider>
    );
}

export { ConfigProvider, ConfigContext };
